import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * FilePatient icon
 *
 * @category Files/Forms/Editing
 */
const FilePatient = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          d="M26.135 10.706c-1.322-1.78-4.213-4.35-6.005-6.215-.667-.63-1.248-1.236-2.187-1.335-2.966 0-8.49-.642-10.652.68-1.334.84-1.865 2.372-1.791 3.892v13.963c.099 2.953-.371 4.164.988 5.82 1.829 1.977 3.423 1.36 7.142 1.483 2.867-.025 5.857.05 8.662-.037 2.743.05 4.449-2.434 4.19-5.03.012-2.99 0-7.08 0-9.872-.013-1.792.061-2.608-.297-3.25l-.062-.099zm-6.957-5.338c.235-.025.668.395 1.236.976 1.409 1.458 3.608 3.448 3.707 4.004 0 .098-.05.16-.148.21-.803.26-1.644.11-2.447.074-1.952-.173-2.496-.902-2.607-2.99 0-.742-.185-1.582.185-2.237l.087-.025zm5.672 20.858c-.519 1.087-1.668 1.557-3.67 1.532h-9.897c-2.756.235-4.77-.852-4.56-3.633.074-4.102-.16-13.048.099-17.46.284-1.952 2.372-2.36 4.077-2.36 2.04.124 4.387-.383 6.08.408.741.519.766 1.409.877 2.274.1 2.001.915 4.003 3.077 4.423 1.668.47 4.448-.148 4.275 2.336-.16 3.472.445 9.07-.308 12.332l-.062.136z"
        />
        <path
          fill="currentColor"
          d="M9.858 13.118c1.604-1.199 4.074-1.176 5.661.038.488.37.883.875 1.136 1.434.072.163.209.523.281.88.036.178.057.366.043.531-.014.162-.065.334-.205.44l-.008.007-.008.005a.54.54 0 0 1-.254.078.4.4 0 0 1-.221-.057.8.8 0 0 1-.251-.256l-.004-.007c-.1-.158-.151-.36-.197-.5l-.002-.002c-.421-1.331-1.766-2.327-3.163-2.327-1.398 0-2.751.98-3.172 2.31-.047.148-.1.368-.235.534a.7.7 0 0 1-.275.205.45.45 0 0 1-.362-.008.5.5 0 0 1-.27-.35 1.2 1.2 0 0 1-.016-.4v-.003a3.87 3.87 0 0 1 1.37-2.432zm2.437-6.774c3.49-.385 3.946 4.777.443 5.008h-.146c-1.51-.054-2.339-1.197-2.413-2.368-.074-1.172.605-2.404 2.11-2.639zm.193 1.148c-.638.073-1.043.573-1.135 1.138-.098.602.164 1.242.86 1.478.509.155.91.071 1.202-.127a1.4 1.4 0 0 0 .56-.896 1.4 1.4 0 0 0-.193-1.04c-.173-.257-.457-.462-.877-.538l-.189-.024h-.097zm10.053 15.585c.804 0 .804 1.235 0 1.235H9.584c-.803 0-.803-1.235 0-1.235zm0-3.709c.804 0 .804 1.235 0 1.235H9.46c-.804 0-.804-1.235 0-1.235z"
        />
      </svg>
    );
  }
);

FilePatient.displayName = 'FilePatient';

export { FilePatient };
